import { ViewProcessor } from "./index";
import { View } from "../index";
import DataBindManager from "../data-bind/index";
import { ContentDataBind } from "../data-bind/types/content";
import { CheckboxDataBind } from "../data-bind/types/checkbox";
import { ValueDataBind } from "../data-bind/types/value";
import { RadioButtonDataBind } from "../data-bind/types/radiobutton";
import { SelectElementDataBind } from "../data-bind/types/selectbox";
import { SelectElementOptionsDataBind } from "../data-bind/types/selectbox-options";
import { AttributeDataBind, SelectedDataBind } from "../data-bind/types/attribute";
import { ClassNameDataBind } from "../data-bind/types/class-name";
import { EventDataBind, ClickEventDataBind, SubmitEventDataBind } from "../data-bind/types/event";
import { DatetimeDataBind } from "../data-bind/types/time";
import { ElementDataBind } from "../data-bind/types/element";

export default class DataBindViewProcessor extends ViewProcessor
{
    public afterRender(view: View): PromiseLike<void>
    {
        let bindManager = new DataBindManager(view);
        bindManager.add(ContentDataBind);
        bindManager.add(CheckboxDataBind);
        bindManager.add(ValueDataBind);
        bindManager.add(RadioButtonDataBind);
        bindManager.add(SelectElementOptionsDataBind);
        bindManager.add(SelectElementDataBind);
        bindManager.add(AttributeDataBind);
        bindManager.add(ClassNameDataBind);
        bindManager.add(EventDataBind);
        bindManager.add(ClickEventDataBind);
        bindManager.add(SubmitEventDataBind);
        bindManager.add(DatetimeDataBind);
        bindManager.add(ElementDataBind);
        bindManager.add(SelectedDataBind);

        bindManager.run();
 

        return super.afterRender(view);
    }
}